import * as React from "react";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function DataGridTable({
  UnitPerfomanceTableData,
  appliedUniversities,
  appliedTimelines,
  appliedTerms,
  appliedUnit,
  appliedTeacher,
}) {
  const navigate = useNavigate(); // Initialize useNavigate

  // const handleRowClick = (params) => {
  //   // Navigate to the detail page, using the sno as a parameter
  //   navigate(`/individualteacher/studentDetails`, { state: { StudentName: params.row.StudentName,Studentid: params.row.id, appliedUniversities: appliedUniversities, appliedTimelines: appliedTimelines , appliedTerms: appliedTerms, appliedUnit: appliedUnit, appliedTeacher: appliedTeacher } }); // Pass the student ID if needed
  // };

  // const columns = [
  //   { field: 'sno', headerName: 'S.no', width: 100 },
  //   { field: 'UniversitySP', headerName: 'University & SP', width: 200 },
  //   { field: 'NameCodeofunit', headerName: 'Name / Code of Unit', width: 400 },
  //   { field: 'Totalengagement', headerName: '% Students Engaged', width: 200 },
  //   { field: 'percentagePhoneengagement', headerName: '% Students Engaged on Sessions', width: 250 },

  //   { field: 'Averagecalltimeperconversation', headerName: 'Avg. Duration per Session (Min.)', width: 250 },
  //   { field: 'Averagecalltimeperstudent', headerName: 'Avg. Session Time Per Student (Min.)', width: 250 },
  //   { field: 'Responsiveness', headerName: ' Messages Responded to in 60 min', width: 250 },
  //   { field: 'Midtermscore', headerName: 'Student Satisfaction (Mid-term)', width: 250 },
  //   { field: 'Endtermscore', headerName: 'Student Satisfaction (End-term)', width: 250 },
  //   { field: 'Assessmentgradingqualityscore', headerName: 'Assessment Grading Quality Score', width: 250 },
  //   { field: 'DiscussionForumScore', headerName: 'Discussion Forum Score', width: 200 },
  //   { field: 'TotalScore', headerName: 'Total Score', width: 200 },
  //   {
  //     field: 'PerformanceCategory',
  //     headerName: 'Performance Category',
  //     width: 200,
  //     renderCell: (params) => {
  //       // Conditionally render the PerformanceCategory cell with text colors
  //       let textColor = '';
  //       switch (params.value) {
  //         case 'A':
  //           textColor = '#4caf50'; // Green text
  //           break;
  //         case 'B':
  //           textColor = '#ffeb3b'; // Yellow text
  //           break;
  //         case 'C':
  //           textColor = '#ff9800'; // Orange text
  //           break;
  //         case 'M':
  //           textColor = '#f44336'; // Red text
  //           break;
  //         default:
  //           textColor = ''; // Default color (no change)
  //       }

  //       return (
  //         <div style={{ color: textColor, textAlign: 'center' }}>
  //           {params.value}
  //         </div>
  //       );
  //     }
  //   },

  // ];
  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      width: 80,
      align: 'left',
      headerAlign: 'left',
      sortable: false, // Prevent sorting on S.No
    },
    {
      field: 'UniversitySP',
      headerName: 'Period',
      width: 180,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'NameCodeofunit',
      headerName: 'Unit',
      width: 300,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'Totalengagement',
      headerName: '% Students Engaged',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'percentagePhoneengagement',
      headerName: '% Students Engaged via 1-1 Sessions',
      width: 180,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'Averagecalltimeperconversation',
      headerName: 'Avg. 1-1 Session Duration (Min)',
      width: 180,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'Averagecalltimeperstudent',
      headerName: 'Avg. Session Time Per Student (Min.)',
      width: 180,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'Responsiveness',
      headerName: 'Messages Responded Within 60 Mins (%)',
      width: 180,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'Midtermscore',
      headerName: 'Student Satisfaction (Mid-term)',
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'Endtermscore',
      headerName: 'Student Satisfaction (End-term)',
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'Assessmentgradingqualityscore',
      headerName: 'Grading Quality Score',
      width: 180,
      align: 'center',
      headerAlign: 'center',
    },
   
     {
      field: 'groupsessionscore',
      headerName: ' Group Sessions Score',
      width: 150,
      align: 'center',
     headerAlign: 'center',
     },
    {
      field: 'DiscussionForumScore',
      headerName: 'Discussion Forum Score',
      width: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'TotalScore',
      headerName: 'Total Score',
      width: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'PerformanceCategory',
      headerName: 'Performance Category',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        let textColor = '';
        switch (params.value) {
          case 'A':
            textColor = '#4caf50';
            break; // Green
          case 'B':
            textColor = '#ffeb3b';
            break; // Yellow
          case 'C':
            textColor = '#ff9800';
            break; // Orange
          case 'M':
            textColor = '#f44336';
            break; // Red
          default:
            textColor = '';
        }
        return (
          <div style={{ color: textColor, fontWeight: 'bold' }}>
            {params.value}
          </div>
        );
      },
    },
  ];

  const rows = (UnitPerfomanceTableData || []).map((item, index) => ({
    id: item.unit_id,
    sno: index + 1,
    UniversitySP: item.university_name,
    NameCodeofunit: item.unit_name_code,
    Totalengagement: item.total_engagement,
    percentagePhoneengagement: item.call_engagement,
    Averagecalltimeperconversation: item.average_duration_per_conversation,
    Averagecalltimeperstudent: item.average_duration_per_student,
    groupsessionscore:item.avg_group_session_quality_score,
    Responsiveness: item.responsiveness,
    Midtermscore: item.mid_term,
    Endtermscore: item.end_term,
    Assessmentgradingqualityscore: item.assessment_grading,
    DiscussionForumScore: item.discussion_forum,
    TotalScore: item.total_score,
    PerformanceCategory: item.performance_category,
  }));

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Starts at the first page
    pageSize: 20, // Shows 20 rows by default
  });
  return (
      <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        localeText={{ noRowsLabel: 'No Past Perfomance available' }}
        rowCount={rows.length} // Ensure correct total row count
        pageSizeOptions={[20, 50, 100]} // Available page sizes
        // onRowClick={handleRowClick}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
  );
}
